import React from 'react';
import { NavLink, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Briefcase, Home, LayoutDashboard, Plus } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { ThemeToggle } from '../common/ThemeToggle';

export const LandlordLayout: React.FC = () => {
    const { hasRole } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const showAddProperty =
        location.pathname === '/landlord' ||
        location.pathname.startsWith('/landlord/properties');

    return (
        <div className="flex flex-col min-h-screen w-full bg-light-bg dark:bg-dark-bg">
            {/* Top Bar */}
            <header className="sticky top-0 z-50 w-full border-b border-light-border dark:border-dark-border bg-light-card/70 dark:bg-dark-card/80 backdrop-blur-md">
                <div className="mx-auto flex items-center justify-between px-4 py-1.5 md:px-6">
                    <div className="flex items-center">
                        <button
                            type="button"
                            onClick={() => navigate('/landlord')}
                            className="p-1.5 rounded-lg text-primary dark:text-golden hover:bg-primary/10 dark:hover:bg-golden/10 transition-colors"
                            title="Landlord Portal"
                        >
                            <LayoutDashboard className="h-4 w-4" />
                        </button>
                    </div>

                    <div className="flex items-center gap-0.5">
                        {hasRole('Business') && (
                            <NavLink
                                to="/business"
                                title="Business"
                                className="p-1.5 rounded-lg text-light-subtle dark:text-dark-subtle hover:text-primary dark:hover:text-golden hover:bg-primary/10 dark:hover:bg-golden/10 transition-colors"
                            >
                                <Briefcase className="h-4 w-4" />
                            </NavLink>
                        )}

                        <NavLink
                            to="/"
                            title="Personal"
                            className="p-1.5 rounded-lg text-light-subtle dark:text-dark-subtle hover:text-primary dark:hover:text-golden hover:bg-primary/10 dark:hover:bg-golden/10 transition-colors"
                        >
                            <Home className="h-4 w-4" />
                        </NavLink>

                        {showAddProperty && (
                            <button
                                type="button"
                                onClick={() => navigate('/landlord/properties/new')}
                                title="Add property"
                                className="p-1.5 rounded-lg text-light-subtle dark:text-dark-subtle hover:text-primary dark:hover:text-golden hover:bg-primary/10 dark:hover:bg-golden/10 transition-colors"
                            >
                                <Plus className="h-4 w-4" />
                            </button>
                        )}

                        <ThemeToggle />
                    </div>
                </div>
            </header>

            {/* Main Content Area */}
            <main className="flex-1 overflow-y-auto w-full">
                <div className="p-6 md:p-8 w-full max-w-[1044px] mx-auto min-h-[calc(100vh-88px)]">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};
